/* Rquiere de mixin.js */

var editorial = {
	data () {
		return {
			listEditorials: [],
			methodsEditorial: {
				get: 'editorials',
				show: 'editorial/',
			},
			paginationEditorials: [],
			searchEditorials: '',
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		getAllEditorials(page = 1) {
			let parameters = '?search=' + this.searchEditorials + '&page=' + page
			this.axiosActionIS(this.getApiBackend + this.methodsEditorial.get + parameters, 'GET', 'getAllEditorialsResult')
        },
		getAllEditorialsResult(response) {
            if(response.data.success) {
                this.listEditorials = response.data.data
                this.paginationEditorials = response.data.paginate    
            }
            this.getAllEditorialsResultLocal(response)
		},
        getAllEditorialsResultLocal(response) {
            console.log('getAllEditorialsResultLocal no desarrollado', response)
        },
		getEditorial(id) {
			this.axiosActionIS(this.getApiBackend + this.methodsEditorial.show + id, 'GET', 'getEditorialResult')
		},
        getEditorialResult(response) {
            this.getEditorialResultLocal(response)
        },
        getEditorialResultLocal(response) {
            console.log('getEditorialResultLocal no está desarrollado', response)
        },
	},
};

export default editorial;